'use strict';

var calendar = require('./liveShoppingCalendar');

function normalizeTimestamp (value) {
    if (value === null || value === undefined) {
        return null;
    }

    var raw = String(value).trim();
    if (!raw) {
        return null;
    }

    if (/^-?\d+$/.test(raw)) {
        var plainNumeric = parseInt(raw, 10);
        if (isNaN(plainNumeric)) {
            return null;
        }

        return plainNumeric < 1000000000000 ? plainNumeric * 1000 : plainNumeric;
    }

    // Handle locale/grouped timestamp strings like 1,746,112,800,000 or 1.746.112.800.000.
    var groupedNumeric = raw.replace(/[\s.,']/g, '');
    if (/^-?\d+$/.test(groupedNumeric)) {
        var normalizedNumeric = parseInt(groupedNumeric, 10);
        if (isNaN(normalizedNumeric)) {
            return null;
        }

        return normalizedNumeric < 1000000000000
            ? normalizedNumeric * 1000
            : normalizedNumeric;
    }

    var parsedDate = Date.parse(raw);
    if (!isNaN(parsedDate)) {
        return parsedDate;
    }

    return null;
}

function formatRemaining (expiration) {
    var diff = expiration - Date.now();
    if (diff < 0) {
        diff = 0;
    }

    var totalMinutes = Math.floor(diff / 60000);
    var days = Math.floor(totalMinutes / (60 * 24));
    var hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    var minutes = totalMinutes % 60;

    return {
        days: days + 'd',
        hours: hours + 'h',
        minutes: minutes + 'm',
    };
}

function updateCountdowns (root) {
    var scope = root || document;
    var countdowns = scope.querySelectorAll(
        '.js-liveShoppingUpcomingCountdown',
    );

    for (var i = 0; i < countdowns.length; i++) {
        var node = countdowns[i];
        var expiration = normalizeTimestamp(
            node.getAttribute('data-expiration'),
        );
        if (!expiration) {
            continue;
        }

        var remaining = formatRemaining(expiration);
        var daysNode = node.querySelector(
            '.js-liveShoppingUpcomingCountdownDays',
        );
        var hoursNode = node.querySelector(
            '.js-liveShoppingUpcomingCountdownHours',
        );
        var minutesNode = node.querySelector(
            '.js-liveShoppingUpcomingCountdownMinutes',
        );

        if (daysNode) {
            daysNode.textContent = remaining.days;
        }
        if (hoursNode) {
            hoursNode.textContent = remaining.hours;
        }
        if (minutesNode) {
            minutesNode.textContent = remaining.minutes;
        }
    }
}

function initUpcomingSection (root, scrollbarApi, scrollbarConfig) {
    var scope = root || document;
    var wrappers = scope.querySelectorAll(
        '.cc-liveShoppingUpcoming-carouselWrap',
    );
    var bindings = [];

    for (var i = 0; i < wrappers.length; i++) {
        var wrapper = wrappers[i];
        var carousel = wrapper.querySelector(
            '.js-liveShoppingUpcomingCarousel',
        );
        var thumb = wrapper.querySelector(
            '.js-liveShoppingUpcomingScrollThumb',
        );

        updateCountdowns(wrapper);

        scrollbarApi.bindScrollbar(carousel, thumb, scrollbarConfig);
        if (carousel && thumb) {
            bindings.push({ carousel: carousel, thumb: thumb });
        }
    }

    calendar.initCalendarButtons();

    return bindings;
}

function updateScrollIndicators (bindings, scrollbarApi, scrollbarConfig) {
    if (!bindings || !bindings.length) {
        return;
    }

    for (var i = 0; i < bindings.length; i++) {
        scrollbarApi.updateScrollIndicator(
            bindings[i].carousel,
            bindings[i].thumb,
            scrollbarConfig,
        );
    }
}

module.exports = {
    initUpcomingSection: initUpcomingSection,
    updateCountdowns: updateCountdowns,
    updateScrollIndicators: updateScrollIndicators,
};
